import AccessTypePill from "@components/Accesses/components/AccessTypePill";
import LBox from "@components/LBox";
import { Access } from "@hooks/trpc/useAccesses";
import { useSongs } from "@hooks/trpc/useSongs";
import { getAccessPresentation } from "@libs/utils";

type AccessTypeChipProps = {
  access: Access;
  compact?: boolean;
  placement?: "bottom-center" | "top-left" | "top-right";
};

const AccessTypeChip = ({
  access,
  compact = false,
  placement = "bottom-center",
}: AccessTypeChipProps) => {
  const accessSong = access.type === "music" ? access.songs.at(0) : undefined;
  const { query } = useSongs(accessSong?.id ? [accessSong.id] : undefined, {
    enabled: !!accessSong?.id,
  });
  const catalogSong = query.data?.at(0);
  const isDjSet = Boolean(accessSong?.isSetList || catalogSong?.isSetList);
  const presentation = getAccessPresentation({
    type: access.type,
    eventKind: access.type === "event" ? access.kind : undefined,
    externalLinks: access.extLinks,
    isSetList: isDjSet,
  });

  if (!presentation) return null;

  return (
    <LBox
      position="absolute"
      bottom={placement === "bottom-center" ? 3 : undefined}
      top={
        placement === "top-left" || placement === "top-right" ? 10 : undefined
      }
      left={placement === "top-left" ? 10 : undefined}
      right={placement === "top-right" ? 10 : undefined}
      alignSelf={placement === "bottom-center" ? "center" : undefined}
    >
      <AccessTypePill presentation={presentation} compact={compact} />
    </LBox>
  );
};

export default AccessTypeChip;
